import account from './en-US/account';
import commerce from './en-US/commerce';
import component from './en-US/component';
import dashboard from './en-US/dashboard';
import globalHeader from './en-US/globalHeader';
import membership from './en-US/membership';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import referrals from './en-US/referrals';
import relationships from './en-US/relationships';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import system from './en-US/system';
import users from './en-US/users';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...dashboard,
  ...users,
  ...membership,
  ...commerce,
  ...relationships,
  ...referrals,
  ...system,
  ...account,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
